module.exports = __webpack_public_path__ + "static/img/areaA-2.3dcca19.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダーエージェント_イラスト/areaA-2.png
// module id = 931
// module chunks = 1